import React from 'react';
import './ListFooter.css'; // 스타일링을 위한 CSS 파일을 임포트합니다.

const ListFooter = ({ page, totalPages, handlePageChange }) => {
  return (
    <div className="paging">
      <button
        onClick={() => handlePageChange(1)}
        disabled={page === 1}
      >
        First
      </button>
      <button
        onClick={() => handlePageChange(page - 1)}
        disabled={page === 1}
      >
        Prev
      </button>
      {Array.from({ length: totalPages }, (_, index) => (
        page === index + 1 ? (
          <span key={index} className="active">
            {index + 1}
          </span>
        ) : (
          <button
            key={index}
            onClick={() => handlePageChange(index + 1)}
          >
            {index + 1}
          </button>
        )
      ))}
      <button
        onClick={() => handlePageChange(page + 1)}
        disabled={page === totalPages}
      >
        Next
      </button>
      <button
        onClick={() => handlePageChange(totalPages)}
        disabled={page === totalPages}
      >
        Last
      </button>
    </div>
  );
};

export default ListFooter;